
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

//router
import { HashRouter as Router,Switch,Route } from 'react-router-dom';

import Login from './views/Pages/Login/';
//import Dashboard from './views/Dashboard/';

//style scss
import '../scss/style.scss';
import 'simple-line-icons/css/simple-line-icons.css';

//router full home
import Full from './containers/Full/';

ReactDOM.render(
  <Router>
    <Switch>
      <Route exact path="/" component={Login} />
      <Route path="/full" name="Full" component={Full}/>
    </Switch>
  </Router>,
  document.getElementById('root')
);
